<template>
    <table class="mt-table work-history-table table-to-cards-768" v-if="jobs.length > 0">
        <thead>
            <th class="toggle"></th>
            <th data-label="Company">Company</th>
            <th data-label="Ticker">Ticker</th>
            <th data-label="Position">Position</th>
            <th data-label="Dates">Dates</th>
            <th data-label="Alpha">Alpha</th>
        </thead>
        <tbody v-for="job in jobs" :key="job.id">
            <tr>
                <ExpandableRowColumn :active="job.titles.length > 1" :expanded.sync="expanded" :value="job" />
                <td data-label="Company">
                    <CompanyAvatar :company="job.company" />
                    <CompanyLink :company="job.company" />
                </td>
                <td data-label="Ticker">
                    <CompanyLink :company="job.company" symbol />
                </td>
                <td data-label="Position">
                    {{ job.title }}
                </td>
                <td data-label="Dates">
                    <FuzzyDateRange :item="job" />
                </td>
                <td data-label="Alpha">
                    {{ formatAlpha(job) }}
                </td>
            </tr>
            <template v-if="expanded.has(job)">
                <tr v-for="(title, index) in job.titles" :key="`${job.id}-${index}`">
                    <td class="toggle"></td>
                    <td data-label="Company"></td>
                    <td data-label="Ticker"></td>
                    <td data-label="position" :title="title.title">
                        {{ title.title }}
                    </td>
                    <td data-label="Dates">
                        <FuzzyDateRange :item="title" />
                    </td>
                    <td data-label="Alpha"></td>
                </tr>
            </template>
        </tbody>
    </table>
    <div class="empty-block" v-else>
        <p class="material-icons company-icon">work</p>
        <h4>No Work History</h4>
        <p>Work History for this executive will appear here!</p>
    </div>
</template>
<script setup>
import { formatNegativeParens } from '@/utils/format'
import ExpandableRowColumn from '@/components/shared/mt-table/ExpandableRowColumn.vue'

import CompanyAvatar from '@/components/companies/avatar.vue'
import CompanyLink from '@/components/companies/CompanyLink'
import FuzzyDateRange from '@/components/executives/FuzzyDateRange.vue'
import { ref } from 'vue'

const props = defineProps({
    jobs: {
        type: Array,
        required: true,
    },
})

const expanded = ref(new Set())

function formatAlpha(row) {
    if (row.alpha === null) {
        return ''
    }

    return formatNegativeParens(row.alpha, { style: 'percent', maximumFractionDigits: 1 })
}
</script>
<style src="@/css/table-to-cards.css" />
<style scoped>
table {
    table-layout: fixed;
}

td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

tr + tr {
    .toggle,
    [data-label='Company'],
    [data-label='Ticker'] {
        border-bottom: none;
    }
}

.toggle {
    border-right: none;
    width: 40px;
}

[data-label='Company'] {
    padding-left: 0;
    width: 50%;
}
[data-label='Ticker'] {
    width: 88px;
    padding: 0;
    white-space: nowrap;
    text-align: center;
}
[data-label='Position'] {
    width: 50%;
}
[data-label='Dates'] {
    width: 176px;
    white-space: normal;
}
[data-label='Alpha'] {
    overflow: visible;
    width: 88px;
}

@media (max-width: 768px) {
    td.toggle {
        display: none;
    }

    [data-label='Company'] {
        img {
            display: none;
        }
    }
    [data-label='Ticker'] {
        text-align: left;
    }
}
</style>
